import NAME from "./constants";

export const SET_TIME = NAME + "/SET_TIME";